import { CustomResponseInterface } from "../../../interfaces/ActionReducer/GetMethod/GetResponse";
import { ListViewFiltersType } from "../../WorkOrders/types";
import { ProposedRegulationReceived } from "../types";
export const SET_REGULATION_TYPE = "SET_REGULATION_TYPE";
export const SET_CHOSEN_PARKING_RATES = "SET_CHOSEN_PARKING_RATES";
export const TOGGLE_EDIT_PARKING_RATES_OPTIONS_PANEL = "TOGGLE_EDIT_PARKING_RATES_OPTIONS_PANEL";
export const TOGGLE_PARKING_RATES_ACTION_PERFORMED = "TOGGLE_PARKING_RATES_ACTION_PERFORMED";
export const SET_DISABLED_IDS = "SET_DISABLED_IDS";
export const IS_EDIT_PARKING_RATES_IN_PROGRESS = "IS_EDIT_PARKING_RATES_IN_PROGRESS";
export const GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS =
    "GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS";
export const PROPOSED_PARKING_RATE_REGULATIONS_RECEIVED =
    "PROPOSED_PARKING_RATE_REGULATIONS_RECEIVED";
export const SHOW_PARKING_RATE_LIST_VIEW = "SHOW_PARKING_RATE_LIST_VIEW";
export const STORE_PROPOSED_PARKING_RATE_REGULATIONS_PARAMS =
    "STORE_PROPOSED_PARKING_RATE_REGULATIONS_PARAMS";
export const DELETE_PARKING_RATE_EDIT_BATCH = "DELETE_PARKING_RATE_EDIT_BATCH";
export const GET_PARKING_RATE_LIST_VIEW_FILTERS = "GET_PARKING_RATE_LIST_VIEW_FILTERS";
export const PARKING_RATE_LIST_VIEW_FILTERS_RECEIVED = "PARKING_RATE_LIST_VIEW_FILTERS_RECEIVED";
export const SHOW_PARKING_BATCH_LIST_VIEW = "SHOW_PARKING_BATCH_LIST_VIEW";
export const PROPOSED_PARKING_BATCH_REGULATIONS_RECEIVED =
    "PROPOSED_PARKING_BATCH_REGULATIONS_RECEIVED";
export const SELECTED_PARKING_RATE_COLUMNS = "SELECTED_PARKING_RATE_COLUMNS";
export const GET_SELECTED_PARKING_RATE_BATCH_DATA = "GET_SELECTED_PARKING_RATE_BATCH_DATA";

export interface SetRegulationTypeAction {
    type: typeof SET_REGULATION_TYPE;
    payload: { regulationType: number[] };
}

export interface GetAllProposedParkingRateRegulationsAction {
    type: typeof GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS;
    payload: {
        params: {
            [index: string]: string | number | boolean | string[];
        };
    };
}

export interface GetSelectedParkingRateBatchData {
    type: typeof GET_SELECTED_PARKING_RATE_BATCH_DATA;
    payload: {
        params: {
            batch_id: number;
            offset: number;
            limit: number;
        };
    };
}

export interface storeProposedParkingRateRegulationsParams {
    type: typeof STORE_PROPOSED_PARKING_RATE_REGULATIONS_PARAMS;
    payload: {
        params: {
            [index: string]: string | number | boolean | string[];
        };
    };
}

export interface ProposedParkingRateRegulationsReceivedAction {
    type: typeof PROPOSED_PARKING_RATE_REGULATIONS_RECEIVED;
    payload: {
        proposedParkingRateRegulations: ProposedParkingRateRegulationsRecords;
    };
}

export interface ProposedParkingBatchRegulationsReceivedAction {
    type: typeof PROPOSED_PARKING_BATCH_REGULATIONS_RECEIVED;
    payload: {
        proposedParkingRateBatchRegulations: {
            meta: {
                count: number;
            };
            results: ProposedRegulationReceived[];
        };
    };
}

export interface ShowParkingRateListViewAction {
    type: typeof SHOW_PARKING_RATE_LIST_VIEW;
    payload: {
        showParkingRateListView: boolean;
    };
}

export interface showParkingBatchListViewAction {
    type: typeof SHOW_PARKING_BATCH_LIST_VIEW;
    payload: { showParkingBatchListView: boolean };
}
export interface DeleteParkingRateEditBatchAction {
    type: typeof DELETE_PARKING_RATE_EDIT_BATCH;
    payload: {
        id: number;
        afterDelete?: () => void;
    };
}
export type ChosenParkingRates =
    | {
          label: string;
          value: number[];
      }[]
    | [];

export interface SetChosenParkingRatesAction {
    type: typeof SET_CHOSEN_PARKING_RATES;
    payload: {
        parkingRates: ChosenParkingRates;
    };
}

export interface ToggleEditParkingRatesOptionsPanelAction {
    type: typeof TOGGLE_EDIT_PARKING_RATES_OPTIONS_PANEL;
    payload: { isOpen: boolean };
}

export interface SetDisabledIdsAction {
    type: typeof SET_DISABLED_IDS;
    payload: { disabledIds: number[] };
}

export interface IsEditParkingRatesEnabledAction {
    type: typeof IS_EDIT_PARKING_RATES_IN_PROGRESS;
    payload: { inProgress: boolean };
}

interface ProposedRegulation {
    id: number;
    regulationId: number;
    sub_activity: {
        display_name: string;
        name: string;
    };
    user: {
        username: string;
    };
    published_on: string | null;
    payment: {
        source: string;
        fees: number[];
        duration: number[];
    };
    is_published: boolean;
}

export interface ProposedParkingRateRegulations {
    created: string;
    modified: string;
    proposed_regulation: ProposedRegulation;
    proposedregulationlinks_set: any;
    original_rate: (number | null)[];
    name: string | null;
    spaces: number;
    id: number;
}

export type ProposedParkingRateRegulationsRecords = CustomResponseInterface<
    ProposedParkingRateRegulations[]
>;

export interface GetParkingRateListViewFiltersAction {
    type: typeof GET_PARKING_RATE_LIST_VIEW_FILTERS;
    payload: {
        params: {
            current_time: string;
            date: string;
            scenario_id: number;
        };
    };
}

export interface SelectedParkingRateColumnsAction {
    type: typeof SELECTED_PARKING_RATE_COLUMNS;
    payload: {
        selectedColumns: string[];
    };
}

export interface ParkingRateListViewFiltersReceivedAction {
    type: typeof PARKING_RATE_LIST_VIEW_FILTERS_RECEIVED;
    payload: {
        data: ListViewFiltersType[];
    };
}

export interface EditParkingRatesState {
    regulationType: number[];
    parkingRates: ChosenParkingRates;
    isEditParkingRatesOptionsPanelOpen: boolean;
    disabledIds: number[];
    isEditParkingRatesInProgress: boolean;
    proposedParkingRateRegulations: ProposedParkingRateRegulationsRecords;
    showParkingRateListView: boolean;
    showParkingBatchListView: boolean;
    proposedParkingRateBatchRegulations: {
        meta: {
            count: number;
        };
        results: ProposedRegulationReceived[];
    };
    isFetchingParkingRateRegulations: boolean;
    proposedParkingRateRegulationsParams: storeProposedParkingRateRegulationsParams["payload"]["params"];
    actionPerformed: boolean;
    parkingRateListViewFilters: ParkingRateListViewFiltersReceivedAction["payload"]["data"];
    selectedColumns: string[];
    isFetchingParkingBatchData: boolean;
}

export type EditBatchSelectionTypes =
    | SetRegulationTypeAction
    | SetChosenParkingRatesAction
    | ToggleEditParkingRatesOptionsPanelAction
    | SetDisabledIdsAction
    | showParkingBatchListViewAction
    | IsEditParkingRatesEnabledAction
    | GetAllProposedParkingRateRegulationsAction
    | ProposedParkingRateRegulationsReceivedAction
    | DeleteParkingRateEditBatchAction
    | SelectedParkingRateColumnsAction;
